<template>
  <div class="about-team-image-carousel">
    <sg-vue-slick-carousel v-if="images.length > 0">
      <figure
        class="image-slide"
        v-for="image in images"
        v-bind:key="image.id"
      >
        <img
          v-bind:data-lazy="image.image"
          v-bind:alt="image.alt_text"
          v-bind:width="image.width"
          v-bind:height="image.height"
        >
        <figcaption
          class="image-caption"
          v-if="image.title"
        >{{ image.title }}</figcaption>
      </figure>
    </sg-vue-slick-carousel>
  </div>
</template>

<script>
import SgVueSlickCarousel from '../utils/SgVueSlickCarousel'

export default {
  name: 'AboutTeamImageCarousel',
  props: ['images'],
  components: {SgVueSlickCarousel},
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .about-team-image-carousel {
    @include centered-block-width($desktop: 60%, $mobile: 100%);
    .image-slide {
      position: relative;
      @media only print {
        position: static;
      }
      & > img {
        display: block;
        width: 100%;
        height: auto;
        &.slick-loading + .image-caption {
          visibility: hidden;
        }
      }
      & > .image-caption {
        position: absolute;
        bottom: 0.75em;
        width: 100%;
        font-size: 1.15em;
        font-weight: bold;
        color: $active-link-color;
        @media print {
          position: static;
          padding-top: 1em;
          font-weight: normal;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/about-team/AboutTeamImageCarousel.vue